import { Wind, Droplets, Heart, Activity, Thermometer } from 'lucide-react';

export const healthIcons = {
  Wind,
  Droplets,
  Heart,
  Activity,
  Thermometer
};